import type {
  DispatchPassengerTagRead,
  DispatchTripTagRead,
  TripTripTagRead,
} from 'src/common/external/bambi-api/bambiApi';
import { getTextColorByBgColor } from 'src/common/util/getTextColorByBgColor';

interface TagProps {
  label: string;
  color: string;
  icon?: React.ReactNode;
  onClick?: () => void;
  'data-testid'?: string;
}
export function Tag({
  label,
  color,
  icon,
  onClick,
  'data-testid': testId,
}: TagProps) {
  const textColor = getTextColorByBgColor(color);
  return (
    <div
      className={`flex rounded-full px-2.5 py-1 text-xs font-medium ${textColor}`}
      style={{ backgroundColor: color }}
      data-testid={testId ?? 'tag'}
    >
      {label.length > 20 ? `${label.slice(0, 20)}...` : label}
      {icon && (
        <span className="ml-1" onClick={onClick}>
          {icon}
        </span>
      )}
    </div>
  );
}

type TripOrPassengerTag =
  | TripTripTagRead
  | DispatchTripTagRead
  | DispatchPassengerTagRead;

interface TripTagProps {
  tag: TripOrPassengerTag;
  icon?: React.ReactNode;
  onIconClick?: (tag: TripOrPassengerTag) => void;
}

export function TripTag({ tag, icon, onIconClick }: TripTagProps) {
  return (
    <Tag
      color={tag.color_hex}
      label={tag.tag_name}
      icon={icon}
      onClick={() => onIconClick?.(tag)}
    />
  );
}
